import { useCallback } from 'react';
import { useAnalyticsEvents as useAnalyticsNextEvents } from '@atlaskit/analytics-next';
import { EVENT_CHANNEL } from './constants';
import createEventPayload from './generated/create-event-payload';
export const useAnalyticsEventsWithTags = () => {
  const {
    createAnalyticsEvent
  } = useAnalyticsNextEvents();
  const fireEventWithTags = useCallback((tags, ...params) => {
    const event = createAnalyticsEvent(createEventPayload(...params));
    if (event.payload) {
      event.payload.tags = tags;
    }
    event.fire(EVENT_CHANNEL);
  }, [createAnalyticsEvent]);
  return {
    fireEventWithTags
  };
};